// extracted by mini-css-extract-plugin
export default {"colorBlue":"#3facdb","breakpointXs":"480","breakpointSm":"640","breakpointMd":"768","breakpointLg":"992","breakpointXl":"1024","breakpoint2xl":"1200"};